import { render, staticRenderFns } from "./ProformaModalLine.vue?vue&type=template&id=5908686f&scoped=true&"
import script from "./ProformaModalLine.vue?vue&type=script&lang=ts&"
export * from "./ProformaModalLine.vue?vue&type=script&lang=ts&"
import style0 from "./ProformaModalLine.vue?vue&type=style&index=0&id=5908686f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908686f",
  null
  
)

export default component.exports